export const COMMENTS_ADD = 'COMMENTS_ADD';
export const COMMENTS_ADDING = 'COMMENTS_ADDING';
export const COMMENTS_LOADING = 'COMMENTS_LOADING';
export const COMMENTS_LOADED = 'COMMENTS_LOADED';
export const COMMENTS_REPLY_ACTIVE = 'COMMENTS_REPLY_ACTIVE';